import { render, staticRenderFns } from "./EditSystem.html?vue&type=template&id=1b89ec9e&external"
import script from "./EditSystem.vue?vue&type=script&lang=js"
export * from "./EditSystem.vue?vue&type=script&lang=js"
import style0 from "./EditSystem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports